document.addEventListener('DOMContentLoaded', function () {
    require('./change-bank');
    require('./change-connection');
    require('./change-debit');
    require('./change-password');
    require('./change-personal');
});
